import React from 'react'
import i18n from 'i18next'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import { Content, Img, Span, ModalFooterComponent, ModalButton } from './mixins'
import { hideModals } from '../../store/modal/actionsToDo'
import imgBM from '../../assets/images/modal-mobile-go-to-desktop-bm.svg'
import imgZJ from '../../assets/images/modal-mobile-go-to-desktop-zj.svg'
import { SITE_ID } from '../../constants'
import { AvisosListadoDataLayers } from '../../constants/gtm-events/gtm-events-avisos-listado'

const ModalFooter = ({ handle }) => {
  return (
    <ModalFooterComponent>
      <ModalButton
        buttonoptions={{
          size: 'medium',
          variant: 'primary',
          type: 'fill',
          native: false,
        }}
        onClick={handle}
      >
        {i18n.t('dashboard.modalMobile.button')}
          </ModalButton>
    </ModalFooterComponent>
  )
}

const Component = ({ activeModal }) => {  
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const modalWidth = 480

  const onClick = (action) => {
    AvisosListadoDataLayers.modalDesktopClick(action)
    dispatch(hideModals())
  }

  return (
    <Modal
      width={modalWidth}
      visible={activeModal === 'modal-mobile-go-to-desktop'}
      skin="with-info"
      title={t('dashboard.modalMobile.title')}
      onClose={()=>onClick('Cerrar')}
      footer={<ModalFooter handle={()=>onClick('Entendido')} />}
    >
      <Content>
        <Span>{t('dashboard.modalMobile.span')}</Span>
        <Img src={SITE_ID === 'ZJAR' ? imgZJ : imgBM} height="252px" width="268px" />
      </Content>
    </Modal>
  )
}

const state = ({ modalStore }) => {
  const { activeModal } = modalStore

  return {
    activeModal,
  }
}
export default connect(state)(Component)
